var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1375 11.9937L7.5 10.5687L9.8625 12.0125L9.24375 9.3125L11.325 7.5125L8.5875 7.26875L7.5 4.71875L6.4125 7.25L3.675 7.49375L5.75625 9.3125L5.1375 11.9937ZM2.86875 15.125L4.0875 9.85625L0 6.3125L5.4 5.84375L7.5 0.875L9.6 5.84375L15 6.3125L10.9125 9.85625L12.1313 15.125L7.5 12.3312L2.86875 15.125Z",
    fill: "#F29F40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/star-empty.cd06aed2c7371f13797b10a14690e74a.svg";
export { ForwardRef as ReactComponent };